<template>
  <!-- 确认框 -->
  <div class="my-mask flex-center" v-if="showConfirm">
    <div class="confirm">
      <div class="title">
        <slot name="title">确认删除</slot>
      </div>
      <div class="content">将删除当前评论，不可恢复哦～</div>
      <div class="btns flex-between">
        <div class="cancel " @click="cancel">取消</div>
        <div class="sure" @click="sure">删除</div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      showConfirm: false,
    },
    methods: {
      sure () {
        this.$emit('sure');
      },
      cancel () {
        this.$emit('cancel');
      }
    },
  };

</script>
<style lang="scss" scoped>
  // mask
  .my-mask {
    position: fixed;
    bottom: 0;
    top: 0;
    left: 0;
    width: 100%;
    z-index: 100;
    background: rgba(0, 0, 0, 0.6);
    justify-content: center;
  }

  // 确认框
  .confirm {
    background: #fff;
    border-radius: 20px;
    width: 560px;
    height: 321px;
    padding: 54px 36px 40px;
    box-sizing: border-box;
    text-align: center;

    .title {
      font-size: 34px;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 48px;
      margin-bottom: 22px;
    }

    .content {
      color: rgba(0, 0, 0, 0.45);
      line-height: 40px;
      font-size: 28px;

      span {
        color: #FE7C3C;
      }
    }

    .btns {
      margin-top: 40px;
      height: 78px;
      line-height: 78px;
      text-align: center;
      color: #B8B8B8;
      font-size: 32px;

      .cancel, .sure {
        border-radius: 39px;
        background: rgba(0, 0, 0, 0.05);
        width: 230px;
        justify-content: center;
        color: rgba(0, 0, 0, 0.45);
      }

      .sure {
        color: #fff;
        background: linear-gradient(153deg, rgba(255, 153, 58, 1) 0%, rgba(254, 124, 60, 1) 100%);
        box-shadow: 0px 2px 6px 0px rgba(254, 124, 60, 0.4);
        box-sizing: border-box;
      }
    }
  }

</style>
